import React from 'react';

import classNames from 'classnames';
import css from './textShield.module.scss';

// попробуйте черемшу
// import i0s from './wildgarlic/ingredients-0-s.img.svg';
// import i0m from './wildgarlic/ingredients-0-m.img.svg';
// import i0l from './wildgarlic/ingredients-0-l.img.svg';

// урожай капусты
import i1s from './cabbage/_ingredients-1-s.img.svg';
import i1m from './cabbage/_ingredients-1-m.img.svg';
import i1l from './cabbage/_ingredients-1-l.img.svg';

// Постное меню
import fastM from './fast/_fast-m.img.svg';
import fastL from './fast/_fast-l.img.svg';
import fastS from './fast/_fast-s.img.svg';

import maslenytsaS from './maslenytsa/_maslenytsa-s.img.svg';
import maslenytsaM from './maslenytsa/_maslenytsa-m.img.svg';
import maslenytsaL from './maslenytsa/_maslenytsa-l.img.svg';

import nectarineS from './nectarine/_nectarine-s.img.svg';
import nectarineM from './nectarine/_nectarine-m.img.svg';
import nectarineL from './nectarine/_nectarine-l.img.svg';

// Уже раскупили
import i6s from './soldout/_soldout-s.img.svg';
import i6m from './soldout/_soldout-m.img.svg';
import i6l from './soldout/_soldout-l.img.svg';

// дачный урожай
import dachaS from './dacha/_dacha-s.img.svg';
import dachaM from './dacha/_dacha-m.img.svg';
import dachaL from './dacha/_dacha-l.img.svg';

// Клара Цеткин
import claraS from './_clara/_clara-s.img.svg';
import claraM from './_clara/_clara-m.img.svg';
import claraL from './_clara/_clara-l.img.svg';

import apricotS from './apricot/_apricot-s.img.svg';
import apricotM from './apricot/_apricot-m.img.svg';
import apricotL from './apricot/_apricot-l.img.svg';

// Одиссея
import odysseyS from './odyssey/odyssey-s.img.svg';
import odysseyM from './odyssey/odyssey-m.img.svg';
import odysseyL from './odyssey/odyssey-l.img.svg';

// урожай зелени
import greenS from './green/_green-s.img.svg';
import greenM from './green/_green-m.img.svg';
import greenL from './green/_green-l.img.svg';

// урожай перца
import pepperS from './pepper/_pepper-s.img.svg';
import pepperM from './pepper/_pepper-m.img.svg';
import pepperL from './pepper/_pepper-l.img.svg';

// урожай цукини
import zucchiniS from './zucchini/_zucchini-s.img.svg';
import zucchiniM from './zucchini/_zucchini-m.img.svg';
import zucchiniL from './zucchini/_zucchini-l.img.svg';

// августовская груша
import pearS from './pear/_pear-s.img.svg';
import pearM from './pear/_pear-m.img.svg';
import pearL from './pear/_pear-l.img.svg';

// Попробуйте фенхель
// import i2s from './fennel/ingredients-2-s.img.svg';
// import i2m from './fennel/ingredients-2-m.img.svg';
// import i2l from './fennel/ingredients-2-l.img.svg';

// Попробуй кольраби
// import i3s from './kohlrabi/ingredients-3-s.img.svg';
// import i3m from './kohlrabi/ingredients-3-m.img.svg';
// import i3l from './kohlrabi/ingredients-3-l.img.svg';

// Попробуй мангольд
// import i4s from './mongold/ingredients-4-s.img.svg';
// import i4m from './mongold/ingredients-4-m.img.svg';
// import i4l from './mongold/ingredients-4-l.img.svg';

// Попробуй бок-чой
// import i5s from './bokchoy/ingredients-5-s.img.svg';
// import i5m from './bokchoy/ingredients-5-m.img.svg';
// import i5l from './bokchoy/ingredients-5-l.img.svg';

// Не стал убирать импорты, чтобы не забыть, что в дев сборку эти шильды уже выгружены
// С летними травами
// import herbsS from './herbs/herbs-s.img.svg';
// import herbsM from './herbs/herbs-m.img.svg';
// import herbsL from './herbs/herbs-l.img.svg';

// урожай свеклы
// import beetrootS from './beetroot/beetroot-s.img.svg';
// import beetrootM from './beetroot/beetroot-m.img.svg';
// import beetrootL from './beetroot/beetroot-l.img.svg';

// Агата
// import agataS from './_agata/agata-s.img.svg';
// import agataM from './_agata/agata-m.img.svg';
// import agataL from './_agata/agata-l.img.svg';

// Каролина
// import carolinaS from './_carolina/carolina-s.img.svg';
// import carolinaM from './_carolina/carolina-m.img.svg';
// import carolinaL from './_carolina/carolina-l.img.svg';

// Шанель
// import chanelS from './_chanel/chanel-s.img.svg';
// import chanelM from './_chanel/chanel-m.img.svg';
// import chanelL from './_chanel/chanel-l.img.svg';

// Кюри
// import curieS from './_curie/curie-s.img.svg';
// import curieM from './_curie/curie-m.img.svg';
// import curieL from './_curie/curie-l.img.svg';

// Фрида
// import fridaS from './_frida/frida-s.img.svg';
// import fridaM from './_frida/frida-m.img.svg';
// import fridaL from './_frida/frida-l.img.svg';

// Гертруда
// import gertrudaS from './_gertruda/gertruda-s.img.svg';
// import gertrudaM from './_gertruda/gertruda-m.img.svg';
// import gertrudaL from './_gertruda/gertruda-l.img.svg';

// Хелена
// import helenaS from './_helena/helena-s.img.svg';
// import helenaM from './_helena/helena-m.img.svg';
// import helenaL from './_helena/helena-l.img.svg';

// Легенда
// import legendM from './legend/legend-m.img.svg';
// import legendS from './legend/legend-s.img.svg';

// Сэмплинг кофе Submarine
// import submarineS from './submarine/submarine-s.img.svg';
// import submarineM from './submarine/submarine-m.img.svg';
// import submarineL from './submarine/submarine-l.img.svg';

// broccoli
// import broccoliS from './broccoli/broccoli-1-s.img.svg';
// import broccoliM from './broccoli/broccoli-1-m.img.svg';
// import broccoliL from './broccoli/broccoli-1-l.img.svg';

// import kabachokS from './kabachok/kabachok-s.img.svg';
// import kabachokM from './kabachok/kabachok-m.img.svg';
// import kabachokL from './kabachok/kabachok-l.img.svg';

// import baklajanS from './baklajan/baklajan-s.img.svg';
// import baklajanM from './baklajan/baklajan-m.img.svg';
// import baklajanL from './baklajan/baklajan-l.img.svg';

// import cornS from './corn/corn-s.img.svg';
// import cornM from './corn/corn-m.img.svg';
// import cornL from './corn/corn-l.img.svg';

// import lisichkiS from './lisichki/lisichki-s.img.svg';
// import lisichkiM from './lisichki/lisichki-m.img.svg';
// import lisichkiL from './lisichki/lisichki-l.img.svg';

// import paprikaS from './paprika/paprika-s.img.svg';
// import paprikaM from './paprika/paprika-m.img.svg';
// import paprikaL from './paprika/paprika-l.img.svg';


// import tefalS from './tefal/tefal-s.img.svg';
// import tefalM from './tefal/tefal-m.img.svg';
// import tefalL from './tefal/tefal-l.img.svg';

// import emilyS from './_emily/emily-s.img.svg';
// import emilyM from './_emily/emily-m.img.svg';
// import emilyL from './_emily/emily-l.img.svg';

// import lamarrS from './_lamarr/lamarr-s.img.svg';
// import lamarrM from './_lamarr/lamarr-m.img.svg';
// import lamarrL from './_lamarr/lamarr-l.img.svg';

// import tsvetaevaS from './_tsvetaeva/tsvetaeva-s.img.svg';
// import tsvetaevaM from './_tsvetaeva/tsvetaeva-m.img.svg';
// import tsvetaevaL from './_tsvetaeva/tsvetaeva-l.img.svg';

// import biomioS from './biomio/biomio-s.img.svg';
// import biomioM from './biomio/biomio-m.img.svg';
// import biomioL from './biomio/biomio-l.img.svg';


export type TShieldTextName = 'kohlrabi' | 'lentenMenu' | 'maslenytsa' | 'tefal' | 'mongold' |
    'oktoberfets' | 'seafood' | 'setGreen' | 'setOrange' | 'setRed' | 'soldout' | 'wildgarlic' | 'women' |
    'cabbage' | 'fennel' | 'bokchoy' | 'february' | 'soldout' | 'herbs' | 'eggplants' | 'dacha' | 'beetroot' | 'zucchini' |
    '_agata' | '_carolina' | '_chanel' | '_curie' | '_clara' | '_frida' | '_gertruda' | '_helena' | 'fast' | 'yapracticum' | 'legend'
    | 'submarine' | 'broccoli' | 'kabachok' | 'corn' | 'lisichki' | 'nectarine' | 'paprika'
    | '_tsvetaeva' | '_lamarr' | '_emily' | 'baklajan' | 'biomio' | 'apricot' | 'odyssey' | 'green' | 'pepper' | 'pear'

interface ITextShieldProps {
    name: TShieldTextName,
    position?: 'static' | 'absolute';
}

const defaultPath = { s: '', m: '', l: '' };

const shieldMap = new Map<TShieldTextName, typeof defaultPath>([
    ['soldout', { s: i6s, m: i6m, l: i6l }],
    ['fast', { s: fastS, m: fastM, l: fastL }],
    ['maslenytsa', { s: maslenytsaS, m: maslenytsaM, l: maslenytsaL }],
    ['_clara', { s: claraS, m: claraM, l: claraL }],

    ['cabbage', { s: i1s, m: i1m, l: i1l }],
    ['nectarine', { s: nectarineS, m: nectarineM, l: nectarineL }],
    ['dacha', { s: dachaS, m: dachaM, l: dachaL }],
    ['apricot', { s: apricotS, m: apricotM, l: apricotL }],
    ['odyssey', { s: odysseyS, m: odysseyM, l: odysseyL }],
    ['green', { s: greenS, m: greenM, l: greenL }],
    ['pepper', { s: pepperS, m: pepperM, l: pepperL }],
    ['zucchini', { s: zucchiniS, m: zucchiniM, l: zucchiniL }],
    ['pear', { s: pearS, m: pearM, l: pearL }],
    // ['wildgarlic', { s: i0s, m: i0m, l: i0l }],
    // ['fennel', { s: i2s, m: i2m, l: i2l }],
    // ['kohlrabi', { s: i3s, m: i3m, l: i3l }],
    // ['mongold', { s: i4s, m: i4m, l: i4l }],
    // ['bokchoy', { s: i5s, m: i5m, l: i5l }],

    // ['_agata', { s: agataS, m: agataM, l: agataL }],
    // ['_carolina', { s: carolinaS, m: carolinaM, l: carolinaL }],
    // ['_chanel', { s: chanelS, m: chanelM, l: chanelL }],
    // ['_curie', { s: curieS, m: curieM, l: curieL }],
    // ['_frida', { s: fridaS, m: fridaM, l: fridaL }],
    // ['_gertruda', { s: gertrudaS, m: gertrudaM, l: gertrudaL }],
    // ['_helena', { s: helenaS, m: helenaM, l: helenaL }],
    // ['_tsvetaeva', { s: tsvetaevaS, m: tsvetaevaM, l: tsvetaevaL }],
    // ['_lamarr', { s: lamarrS, m: lamarrM, l: lamarrL }],
    // ['_emily', { s: emilyS, m: emilyM, l: emilyL }],
    // Добавить L
    // ['legend', { s: legendS, m: legendM, l: legendM }],
    // ['submarine', { s: submarineS, m: submarineM, l: submarineL }],
    // ['broccoli', { s: broccoliS, m: broccoliM, l: broccoliL }],
    // ['kabachok', { s: kabachokS, m: kabachokM, l: kabachokL }],
    // ['baklajan', { s: baklajanS, m: baklajanM, l: baklajanL }],
    // ['corn', { s: cornS, m: cornM, l: cornL }],
    // ['lisichki', { s: lisichkiS, m: lisichkiM, l: lisichkiL }],
    // ['paprika', { s: paprikaS, m: paprikaM, l: paprikaL }],
    // ['tefal', { s: tefalS, m: tefalM, l: tefalL }],


    // ['biomio', { s: biomioS, m: biomioM, l: biomioL }],
]);

export const TextShieldV2 = ({ name, position = 'absolute' }: ITextShieldProps) => {
    const rootStyles = classNames({
        [css.textShieldRootV2]: true,
        [css[position]]: true,
    });
    const path = shieldMap.get(name) || defaultPath;

    if (!path) {
        return null;
    }

    return (
        <div
            className={rootStyles}
        >
            <div className={css.s}>
                <img className={css.textShieldImgV2} src={path.s} alt={name} />
            </div>
            <div className={css.m}>
                <img className={css.textShieldImgV2} src={path.m} alt={name} />
            </div>
            <div className={css.l}>
                <img className={css.textShieldImgV2} src={path.l} alt={name} />
            </div>
        </div>
    );
};
